import React, { useState, useEffect } from 'react';
import './convocatorias.css';

const InvierteH2 = () => {
   
  const [expandida, setExpandida] = useState(null);
    
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleImagen = (id) => {
    setExpandida(expandida === id ? null : id);
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3 
            className='title'
            style={{ 
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Invierte en Ti, Invierte en Hidalgo 2026 Segunda Edición 
          </h3>
          {/* IMAGEN 2 */}
          <div className="hero">
            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/InvierteH2.png"
                alt="BMT"
                className={expandida === 2 ? "img expandida" : "img"}
                onClick={() => toggleImagen(2)}
              />
            </div>
          </div>

          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Consulta la convocatoria
          </h5>

          {/* BOTÓN PRINCIPAL */}
          <div className="botones">
            <a href="/documento/33" className="btn-vino">
              Descargar
            </a>
          </div>
         
          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default InvierteH2;